import { Box, Typography } from '@mui/material';
import React from 'react';
import { ExoSalesObjectMatching } from '../../../components/exo/ExoSalesObjectMatching';
import { useTranslation } from 'react-i18next';

export const SalesObjectCustomerMatching = ({ salesObjectId }) => {
  const { t } = useTranslation();

  return (
    <Box className="w-full max-w-[800px] h-full flex flex-col overflow-hidden">
      <Typography variant="h4" className="pb-1">
        {t('Matches')}
      </Typography>
      <Typography className="pb-4 opacity-70">
        {t(
          'A list of all hits that were determined based on the purchasing parameters stored in Leads'
        )}
      </Typography>
      <ExoSalesObjectMatching source={'salesObject'} sourceId={salesObjectId} />
    </Box>
  );
};
